import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { fetchPortalSession, portalSessionQueryKey } from '@/lib/portal';
import { currentBrand } from '@/lib/brand';
import { PortalShell } from '@/features/portal/PortalShell';
import { AlfenPortalShell } from '@/features/portal/AlfenPortalShell';

// The signed-in portal (docs/portal.md). No portal session → the gateway login;
// a session from a recovery code → linking a new phone first, nothing else.
export const Route = createFileRoute('/portal/_portal')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.fetchQuery({
      queryKey: portalSessionQueryKey,
      queryFn: fetchPortalSession,
      staleTime: 30_000,
    });
    if (!me) throw redirect({ to: '/login', search: { redirect: location.href } });
    if (me.mustRelink && location.pathname !== '/portal/new-phone') {
      throw redirect({ to: '/portal/new-phone' });
    }
    return { me };
  },
  component: PortalLayout,
});

// The same screens in two shells: on the names of Alfen a sidebar, on our own
// name the bar at the top (docs/alfen-portaal-bouwlijst.md, besluit 5).
function PortalLayout() {
  const { me } = Route.useRouteContext();
  const Shell = currentBrand() === 'alfen' ? AlfenPortalShell : PortalShell;
  return (
    <Shell me={me}>
      <Outlet />
    </Shell>
  );
}
